// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"vkpsL","quantityLabel":"J3weo","bundleModalWrapper":"ZePu5","changeQuantityContainer":"x3-k-"};